import { Modal, ModalProps } from 'antd'
import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { ChangePasswordForm } from './ChangePasswordForm'
import { ConfirmChangePasswordOtpCode } from './ConfirmChangePasswordOtpCode'

type Props = {
  onCancel: () => void
  mfaAccessToken?: string
  expireOtpCode?: number
} & ModalProps

export const ChangePasswordModal = ({
  onCancel,
  mfaAccessToken,
  expireOtpCode,
  ...props
}: Props) => {
  const { t } = useTranslation()

  const [step, setStep] = useState<number>(0)
  const [passwordToken, setPasswordToken] = useState<string>()

  const onNextStep = (token: string) => {
    setStep(1)
    setPasswordToken(token)
  }

  const steps = [
    {
      title: t('auth.change_password_header'),
      content: (
        <ConfirmChangePasswordOtpCode
          onCancel={onCancel}
          mfaAccessToken={mfaAccessToken}
          onNextStep={onNextStep}
          expireOtpCode={expireOtpCode}
        />
      )
    },
    {
      title: t('auth.change_password_header'),
      content: (
        <ChangePasswordForm onCancel={onCancel} passwordToken={passwordToken} />
      )
    }
  ]

  return (
    <Modal
      {...props}
      footer={null}
      onCancel={onCancel}
      title={steps?.[step]?.title}
    >
      {steps?.[step]?.content}
    </Modal>
  )
}
